import { render, staticRenderFns } from "./Wap_SZR7_Step3.vue?vue&type=template&id=58bbcead&scoped=true&"
import script from "./Wap_SZR7_Step3.vue?vue&type=script&lang=js&"
export * from "./Wap_SZR7_Step3.vue?vue&type=script&lang=js&"
import style0 from "./Wap_SZR7_Step3.vue?vue&type=style&index=0&id=58bbcead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bbcead",
  null
  
)

export default component.exports